var map = {
	"./game/1-1.jpg": "b6c5",
	"./game/1-2.jpg": "4d3f",
	"./game/1-3.jpg": "abc0",
	"./game/1-4.jpg": "a45c",
	"./game/2-1.jpg": "21e4",
	"./game/2-2.jpg": "fb2d",
	"./game/2-3.jpg": "e985",
	"./game/2-4.jpg": "94dd",
	"./game/3-1.jpg": "34a7",
	"./game/3-2.jpg": "6bb7",
	"./game/3-3.jpg": "bc7e",
	"./game/3-4.jpg": "2618",
	"./game/4-1.jpg": "4da6",
	"./game/4-2.jpg": "4c19",
	"./game/4-3.jpg": "b28b",
	"./game/4-4.jpg": "c8e6",
	"./game/5-1.jpg": "6edf",
	"./game/5-2.jpg": "0be2",
	"./game/5-3.jpg": "be7b",
	"./game/5-4.jpg": "d644",
	"./game/6-1.jpg": "b553",
	"./game/6-2.jpg": "27ad",
	"./game/6-3.jpg": "582b",
	"./game/6-4.jpg": "b4b1",
	"./hardware/1-1.jpg": "f75d",
	"./hardware/1-2.jpg": "89ca",
	"./hardware/1-3.jpg": "fb2a",
	"./hardware/1-4.jpg": "0ad0",
	"./hardware/2-1.jpg": "aae7",
	"./hardware/2-2.jpg": "6e3f",
	"./hardware/2-3.jpg": "c972",
	"./hardware/2-4.jpg": "c1cf",
	"./hardware/3-1.jpg": "6b22",
	"./hardware/3-2.jpg": "3a49",
	"./hardware/3-3.jpg": "9c00",
	"./hardware/3-4.jpg": "35d3",
	"./hardware/4-1.jpg": "20d5",
	"./hardware/4-2.jpg": "f4f2",
	"./hardware/4-3.jpg": "5209",
	"./hardware/4-4.jpg": "bfba",
	"./hardware/5-1.jpg": "3cc3",
	"./hardware/5-2.jpg": "c1cc",
	"./hardware/5-3.jpg": "2ad3",
	"./hardware/5-4.jpg": "aea2",
	"./hardware/6-1.jpg": "1672",
	"./hardware/6-2.jpg": "cded",
	"./hardware/6-3.jpg": "2c5d",
	"./hardware/6-4.jpg": "634b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c6d2";